import { AxiosError, AxiosResponse } from "axios";
import { IGetListRequest, IResponse, IServerError } from "../models/common";
import {
	IOntarioEht,
	IOntarioEhtListPayload,
	IOntarioEhtResponse,
} from "../models/OntarioEht";

import { format422Errors } from "../common/Common";
import http from "../common/http-commons";

export const OntarioEhtService = {
	getOntarioEht: async (
		clientId: string,
		remittanceFrequencyId: string | undefined,
		taxYear: number,
		managedBy: number,
		navigateToLogout: (path: string) => void,
	): Promise<
		| IOntarioEhtListPayload
		| IServerError
		| IResponse
		| IOntarioEhtResponse[]
		| null
	> => {
		if (!remittanceFrequencyId) return null;
		try {
			const response: AxiosResponse<IOntarioEhtListPayload> =
				await http.get<IOntarioEhtListPayload>(
					"/v1/eht-remittance/?client_id=" +
						clientId +
						"&remittance_frequency_id=" +
						remittanceFrequencyId +
						"&tax_year=" +
						taxYear +
						"&managed_by=" +
						managedBy,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getOntarioEhtSavedFrequency: async (
		clientId: string,
		taxYear: number,
		navigateToLogout: (path: string) => void,
	): Promise<
		| IOntarioEhtListPayload
		| IServerError
		| IResponse
		| IOntarioEhtResponse[]
		| null
	> => {
		try {
			const response: AxiosResponse<IOntarioEhtListPayload> =
				await http.get<IOntarioEhtListPayload>(
					"/v1/eht-remittance/" + clientId + "/?tax_year=" + taxYear,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	create: async (
		requestPayload: any,
	): Promise<IOntarioEht | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IOntarioEht> = await http.put<IOntarioEht>(
				"/v1/eht-remittance/",
				requestPayload,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delOntarioEht: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		const updatedDeleteDataPayload = {
			...delPayload.ontarioEhtRowData,
			remitAmount: null,
			penaltyPercentage: null,
			penaltyCalculated: null,
			chequeNo: null,
			chequeDate: null,
			status: "Due",
		};
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<IOntarioEht> = await http.put<IOntarioEht>(
				"/v1/eht-remittance/",
				{ data: [updatedDeleteDataPayload] },
			);

			if (response.status === 200) {
				return "Record has been deleted successfully.";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getRemittanceFrequencyDDL: async (): Promise<
		any | IServerError | IResponse | null | any
	> => {
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/remittance-frequency/remittance-frequency-ddl`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 404) {
				return [];
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 404) {
				return [];
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	createOntarioEhtFrequency: async (requestPayload: {
		clientId: string;
		taxYear: number;
		navigateToLogout: (path: string) => void;
		exemptionAmount: number;
		totalGrossPaidInYear: number;
		associatedEmployers: boolean;
		remittanceFrequencyId: string;
		managedBy: number;
	}): Promise<IOntarioEht | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IOntarioEht> = await http.post<IOntarioEht>(
				`/v1/eht-remittance/?client_id=${requestPayload.clientId}&tax_year=${requestPayload.taxYear}&remittance_frequency_id=${requestPayload.remittanceFrequencyId}&managed_by=${requestPayload.managedBy}`,
				requestPayload,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	createOntarioEht: async (requestPayload: {
		clientId: string;
		taxYear: number;
		navigateToLogout: (path: string) => void;
		exemptionAmount: number;
		totalGrossPaidInYear: number;
		associatedEmployers: boolean;
		remittanceFrequencyId: string;
		managedBy: number;
	}): Promise<IOntarioEht | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IOntarioEht> = await http.post<IOntarioEht>(
				// `/v1/eht-remittance/?client_id=${requestPayload.clientId}&tax_year=${requestPayload.taxYear}`,requestPayload
				`/v1/eht-remittance/?client_id=${requestPayload.clientId}&tax_year=${requestPayload.taxYear}&remittance_frequency_id=${requestPayload.remittanceFrequencyId}&managed_by=${requestPayload.managedBy}`,
				requestPayload,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	submitAddRemoveHeaderColumns: async (
		requestPayload: any,
	): Promise<IOntarioEht | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IOntarioEht> = await http.post<IOntarioEht>(
				"/v1/eht-ontario/",
				requestPayload.columns,
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	submitColumnReorder: async (
		requestPayload: any,
	): Promise<IOntarioEht | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IOntarioEht> = await http.post<IOntarioEht>(
				"/v1/eht-ontario/header-columns",
				requestPayload.headerColumns,
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	exportEHTOntarioRemittanceExcelReport: async (
		clientId: string,
		remittanceFrequencyId: string,
		taxYear: number,
		managedBy: number,
	): Promise<any | IServerError | IResponse | any> => {
		const url = `/v1/all-remittance-printing/eht-ontario-remittance-xlsx?client_id=${clientId}&remittance_frequency_id=${remittanceFrequencyId}&tax_year=${taxYear}&managed_by=${managedBy}`;
		const response: any = await http.get(url, {
			responseType: "arraybuffer",
		});

		if (response.status === 201) {
			return response.data;
		} else if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			const text = new TextDecoder().decode(response.data);
			const responseObject = JSON.parse(text);
			let response400 = {
				...response,
				data: responseObject,
			};
			return response400;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}
		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},

	getEHTRemittanceSetting: async (
		clientId: string,
		taxYear: number,
		navigateToLogout: (path: string) => void,
	): Promise<any | IServerError | IResponse | any[] | null> => {
		if (!clientId) return null;
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/eht-remittance-setting/${clientId}/?tax_year=${taxYear}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	createEHTRemittanceSetting: async (
		requestPayload: any,
	): Promise<IOntarioEht | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IOntarioEht> = await http.post<IOntarioEht>(
				"/v1/eht-remittance-setting/",
				requestPayload,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
};
